import { Highlight } from '@orama/highlight'
export * from './results'

export const highlighter = new Highlight({
  HTMLTag: 'mark',
  CSSClass: 'searchbox__result__highlight'
})
